import MoyasarForm from "./MoyaserForm";
import { IoMdClose } from "react-icons/io";

type MoyaserModalProps = {
  paymentData: string | null;
  onCloseMoyaserModal: () => void;
  ModalTitle: string | null;
};

function MoyaserModal({
  paymentData,
  onCloseMoyaserModal,
  ModalTitle,
}: MoyaserModalProps) {
  return (
    <div
      className="fixed inset-0 z-[9999] flex items-start justify-center bg-black/50 pt-[70px]"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30 pb-2">
        <div className="relative flex w-[90%] max-w-2xl flex-col gap-3 rounded-lg bg-white px-4 py-3 pb-5 shadow-lg sm:px-5 sm:py-5 md:gap-7">
          <IoMdClose
            size={24}
            className="absolute end-2 top-2 cursor-pointer text-red-600"
            onClick={onCloseMoyaserModal}
          />

          <h2 className="text-lg font-semibold">{ModalTitle}</h2>

          <div className="flex w-full">
            <div className="w-full">
              <MoyasarForm paymentData={paymentData} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MoyaserModal;
